import {
  EDIT_CHARTCOLOR,
  LIST_CHARTCOLOR,

  CHARTCOLOR_SUCCESS,
  CHARTCOLOR_ERROR,

} from "./actionTypes"

// edit ChartColor
export const editChartColor = (data, id, callback) => {
  return {
    type: EDIT_CHARTCOLOR,
    payload: { data, id, callback },
  }
}

// list ChartColor
export const listChartColor = (data, callback) => {
  return {
    type: LIST_CHARTCOLOR,
    payload: { data, callback },
  }
}


export const chartColorSuccess = message => {
  return {
    type: CHARTCOLOR_SUCCESS,
    payload: message,
  }
}

export const chartColorError = message => {
  return {
    type: CHARTCOLOR_ERROR,
    payload: message,
  }
}
